<template>
  <div class="edit-card-content">
    <textarea-autosize class="title-input" v-model="title" placeholder="Название карточки" :important="true" />
    <textarea class="description" v-model="description" placeholder="Описание"></textarea>

    <CardImages class="card-images" :card="card" />
    <CardLinks class="card-links" :text="description" />

    <Files :card="card" />

    <div class="fields-container">
      <div class="fields">
        <div class="field" v-for="field in fields" :key="'int_' + field.boardField.id">
          <span class="cell field-description">{{ field.boardField.description }}</span>
          <div class="cell field-value">
            <input type="numeric" pattern="[-+]?[0-9]*[\.,]?[0-9]+" title="Не верный формат числа" v-model="field.value" />
          </div>
          <span v-if="field.boardField.suffix" class="cell field-suffix pl-1">{{ field.boardField.suffix }}</span>
        </div>
        <div class="field" v-for="field in fieldsTxt" :key="'txt_' + field.boardField.id">
          <span class="cell field-description">{{ field.boardField.description }}</span>
          <div class="cell field-value">
            <input type="text" v-model="field.value" />
          </div>
          <span v-if="field.boardField.suffix" class="cell field-suffix pl-1">{{ field.boardField.suffix }}</span>
        </div>
      </div>
    </div>
    <Alarms class="alarms" :alarms="alarms" />
    <div class="buttons">
      <Button title="Сохранить" class="save green" @click="save()" icon="save" />
      <Button title="Отменить" class="cancel red" @click="cancel()" icon="times" />
      <Button :title="archived ? 'Из архива' : 'В архив'" class="archive gray" @click="archive()" icon="archive" />
    </div>
  </div>
</template>
<script>
import cache from "@/store/cache";

import CardImages from "./CardImages.vue";
import CardLinks from "./CardLinks.vue";
import Files from "./Files.vue";
import Alarms from "./../alarms/Alarms.vue";

export default {
  name: "EditCardContent",
  components: {
    CardImages,
    Files,
    CardLinks,
    Alarms
  },
  props: ["card"],
  computed: {
    board() {
      if (!this.card) {
        return null;
      }
      return cache.boards.byId(this.card.board_id);
    },
    archived() {
      if (!this.card) {
        return false;
      }

      return this.card.archived;
    }
  },
  data() {
    return {
      alarms: [],
      title: "",
      description: "",
      fields: [],
      fieldsTxt: []
    };
  },
  created() {
    this.$eventHub.$on("command-save", this.save);
    this.$eventHub.$on("command-cancel", this.cancel);
  },
  beforeDestroy() {
    this.$eventHub.$off("command-save");
    this.$eventHub.$off("command-cancel");
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    save() {
      if (this.title && this.card.title != this.title) {
        this.$store.dispatch("cards/editTitle", {
          card: this.card,
          title: this.title
        });
      }
      if (this.card.description != this.description) {
        this.$store.dispatch("cards/editDescription", {
          card: this.card,
          description: this.description
        });
      }

      this.fields.forEach((f) => {
        let value = f.value;
        if (typeof value === "string") {
          try {
            if (f.value) {
              f.value = f.value.replace(",", ".");
            }
            value = parseFloat(f.value);
          } catch {
            //ignore
            value = 0;
          }
        }

        const existing = this.card.fields.find((cf) => cf.boardField == f.boardField);
        if (!existing) {
          if (value) {
            this.$store.dispatch("fieldsInt/newCard", {
              card: this.card,
              value: value,
              boardField: f.boardField
            });
          }
          return;
        }

        if (existing.value != value) {
          this.$store.dispatch("fieldsInt/editCard", {
            value: value,
            field: existing
          });
        }
      });

      this.fieldsTxt.forEach((f) => {
        let value = "";
        if (f.value) {
          value = f.value;
        }

        const existing = this.card.fieldsTxt.find((cf) => cf.boardField == f.boardField);
        if (!existing) {
          if (value) {
            this.$store.dispatch("fieldsTxt/newCard", {
              card: this.card,
              value: value,
              boardField: f.boardField
            });
          }
          return;
        }

        if (existing.value != value) {
          this.$store.dispatch("fieldsTxt/editCard", {
            value: value,
            field: existing
          });
        }
      });

      this.alarms.forEach((alarm) => {
        if (!alarm.id) {
          this.$store.dispatch("alarms/new", {
            list: cache.lists.byId(this.card.list_id),
            card: this.card,
            alarm: alarm
          });
          return;
        }

        const existing = this.card.alarms.find((a) => a.id == alarm.id);
        if (!existing) {
          return;
        }

        this.$store.dispatch("alarms/update", {
          list: cache.lists.byId(this.card.list_id),
          card: this.card,
          newAlarm: alarm,
          oldAlarm: existing
        });
      });

      this.cancel();
    },
    archive() {
      const _this = this;
      if (this.card.archived) {
        this.$modal.show("ConfirmationDialog", {
          message: "Точно убрать карточку <b>из архива</b>?",
          yes: () => {
            this.$store.dispatch("cards/dearchive", this.card);
            _this.cancel();
          }
        });
      } else {
        this.$modal.show("ConfirmationDialog", {
          message: "Точно переместить карточку в <b>Архив</b>?<br>Ее не будет после этого на Доске.",
          yes: () => {
            this.$store.dispatch("cards/archive", this.card);
            _this.cancel();
          }
        });
      }
    },
    createFields() {
      const fields = [];
      const fieldsTxt = [];
      this.board.fields.forEach((bf) => {
        const existingCardField = this.card.fields.find((cf) => cf.boardField === bf);
        const cardField = {
          boardField: bf,
          value: 0
        };
        if (existingCardField) {
          cardField.cardField = existingCardField;
          cardField.value = existingCardField.value;
        }

        fields.push(cardField);
      });

      this.board.fieldsTxt.forEach((bf) => {
        const existingCardField = this.card.fieldsTxt.find((cf) => cf.boardField === bf);
        const cardField = {
          boardField: bf,
          value: ""
        };
        if (existingCardField) {
          cardField.cardField = existingCardField;
          cardField.value = existingCardField.value;
        }

        fieldsTxt.push(cardField);
      });

      console.log(fields);
      fields.sort((f1, f2) => f1.boardField.description.localeCompare(f2.boardField.description));
      fieldsTxt.sort((f1, f2) => f1.boardField.description.localeCompare(f2.boardField.description));

      this.fields = fields;
      this.fieldsTxt = fieldsTxt;
    },
    setFromCard() {
      if (!this.card) return;
      this.title = this.card.title;
      this.description = this.card.description;
      this.createFields();

      this.alarms = this.card.alarms.map((a) => Object.assign({}, a));
    }
  },
  mounted() {
    this.setFromCard();
  },
  watch: {
    card: function () {
      this.setFromCard();
    }
  }
};
</script>
<style lang="postcss">
.edit-card-content {
  display: grid;
  grid-gap: 0.2em;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto auto auto auto;
  grid-template-areas:
    "title"
    "description"
    "card-images"
    "card-links"
    "card-fields"
    "alarms"
    "buttons";
  height: 100%;

  .title-input {
    padding: 5px;
    font-size: 20px !important;
    font-weight: 700;
  }

  .title-input {
    grid-area: title;
  }

  .description {
    grid-area: description;
    min-height: 80px;
  }

  .card-images {
    grid-area: card-images;
    max-height: 150px;
  }

  .card-links {
    grid-area: card-links;
    max-height: 60px;
    overflow-y: auto;
  }

  .fields-container {
    grid-area: card-fields;
  }

  .alarms {
    grid-area: alarms;
  }

  .buttons {
    grid-area: buttons;
    display: grid;
    grid-gap: 0.2em;
    grid-template-rows: 1fr;
    grid-template-columns: 10fr 10fr 8fr;
  }

  .fields {
    display: table;

    .field {
      display: table-row;

      .cell {
        padding: 3px;
        display: table-cell;
      }

      &-description {
        word-wrap: unset;
        white-space: nowrap;
      }
      &-value {
        word-wrap: unset;
        white-space: nowrap;
        width: 100%;

        input {
          width: 100%;
        }
      }
      &-suffix {
        word-wrap: unset;
        white-space: nowrap;
      }
    }
  }
}
</style>
